<template>
  <div>
    <el-container direction="vertical">
      <el-row style="margin-bottom: 0px;margin-top: 10px;">
        <el-card shadow="never" style="margin-left: 20px;" :body-style="{ padding: '10px' }">
          <div slot="header" class="clearfix">
            <span>2型糖尿病患者规范管理</span>
            <el-row style="float: right;">
              <!-- <el-menu style="float: right;margin-top: -21px;" default-active="1" mode="horizontal">
                <el-menu-item index="1">月</el-menu-item>
                <el-menu-item index="2">季</el-menu-item>
                <el-menu-item index="3">年</el-menu-item>
              </el-menu> -->

              <el-select v-model="period" placeholder="请选择">
                <el-option v-for="item in periodOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>

              <el-date-picker style="margin-left: 5px;" v-model="periodMonth" type="month" placeholder="选择月"
                v-if="period == '月'">
              </el-date-picker>
              <el-date-picker style="margin-left: 5px;" v-model="periodYear" type="year" placeholder="选择年"
                v-if="period == '年' || period == '季'">
              </el-date-picker>
              <el-select style="margin-left: 5px;" v-model="periodQuarter" placeholder="选择季" v-if="period == '季'">
                <el-option v-for="item in periodQuarterOptions" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <el-button style="margin-left: 5px;" type="primary" @click="getList">确定</el-button>
            </el-row>

          </div>

          <div>
            <el-col style="width: 250px">
              <el-card style="
                margin-top: 0px;
                margin-left: 0px;
                margin-right: 0px;
                margin-bottom: 10px;
                width: 250px;
              ">
                <el-row style="width: 210px; margin-left: 22px">
                  <el-col :span="2">
                    <img style="
                      margin-left: -34px;
                      margin-top: 0px;
                      width: 30px;
                      height: 20px;
                    " :src="linkLine" />
                  </el-col>

                  <el-col :span="22">
                    <span style="margin-left: -25px">血糖检测</span>
                  </el-col>
                </el-row>

                <el-row style="margin-top: 10px; width: 210px">
                  <el-card style="background-color: #e7f8fe;border-color: #e7f8fe;">
                    <div>
                      <el-row>
                        <el-col :span="3">
                          <el-button circle size="mini" style="background-color: green;" />
                        </el-col>
                        <el-col :span="13">
                          <div style="font-size: 14px;margin-top: 7px;">
                            血糖检测人次
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div style="font-size: 24px; font-weight: bold;margin-top: 0px;">
                            {{ detail.measBsCount }}
                          </div>
                        </el-col>
                      </el-row>

                      <el-row style="margin-top: 10px;">
                        <el-col :span="16">
                          <div style="font-size: 14px; color: #7b7b7f;">
                            血糖检测达标人次
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div style="font-size: 24px; color: green; font-weight: bold;margin-top: -6px;">
                            {{ detail.measBsStdCount }}
                          </div>
                        </el-col>
                      </el-row>

                      <el-row style="margin-top: 20px;">
                        <el-col :span="3">
                          <el-button circle size="mini" style="background-color: cornflowerblue;" />
                        </el-col>
                        <el-col :span="13">
                          <div style="font-size: 14px;margin-top: 7px;">
                            血糖检测人数
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div style="font-size: 24px; font-weight: bold;margin-top: 0px;">
                            {{ detail.measBsPersonCount }}
                          </div>
                        </el-col>
                      </el-row>

                      <el-row style="margin-top: 10px;">
                        <el-col :span="16">
                          <div style="font-size: 14px; color: #7b7b7f;">
                            血糖检测规范人数
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div style="font-size: 24px; color: cornflowerblue; font-weight: bold;margin-top: -6px;">
                            {{ detail.measBsStdPersonCount }}
                          </div>
                        </el-col>
                      </el-row>

                      <el-row>
                        <pie-chart :chart-data="bgChartData" />
                      </el-row>

                    </div>
                  </el-card>
                </el-row>

                <el-row style="margin-top: 10px; width: 210px">
                  <el-card style="background-color: #f3f5fe;">
                    <div>
                      <el-row>
                        <div style="font-size: 14px; color: #7b7b7f;">
                          血糖控制率
                        </div>
                      </el-row>

                      <el-row style="margin-top: 10px; margin-bottom: 10px">
                        <div style="font-size: 24px; font-weight: bold">
                          {{ detail.ctlRateBs }}
                        </div>
                      </el-row>

                      <el-row>
                        <el-progress :percentage="82.2"></el-progress>
                      </el-row>

                      <el-row style="margin-top: 20px;margin-bottom: 25px;">
                        <!-- <el-col :span="12"> -->
                        <div style="font-size: 12px;">
                          月同比 16%
                          <i class="el-icon-caret-top" style="color: red;"></i>
                        </div>
                        <!-- </el-col>                        -->
                      </el-row>
                    </div>
                  </el-card>
                </el-row>
              </el-card>
            </el-col>

            <el-col style="width: 450px;margin-left: 5px;">
              <el-card style="
                margin-top: 0px;
                margin-left: 0px;
                margin-right: 5px;
                margin-bottom: 10px;
                width: 450px;
              ">
                <el-row style="width: 410px; margin-left: 22px">
                  <el-col :span="1">
                    <img style="
                      margin-left: -34px;
                      margin-top: 0px;
                      width: 30px;
                      height: 20px;
                    " :src="linkLine" />
                  </el-col>

                  <el-col :span="23">
                    <span style="margin-left: -20px">协诊规范</span>
                  </el-col>
                </el-row>

                <el-row style="margin-top: 10px;">
                  <!-- 红色患者人次 -->
                  <el-col :span="8">
                    <el-row>
                      <el-col :span="1">
                        <el-button circle size="mini" style="background-color: red;" />
                      </el-col>
                      <el-col :span="23">
                        <div style="font-size: 14px;text-align: center;margin-top: 8px;margin-left: -10px;">
                          “红色”患者人次
                        </div>
                      </el-col>
                    </el-row>

                    <el-row style="margin-top: 5px; margin-bottom: 5px">
                      <div style="font-size: 24px; color: #68bbc4; font-weight: bold;text-align: center;">
                        349人次
                      </div>
                    </el-row>
                  </el-col>

                  <!-- 黄色患者人次 -->
                  <el-col :span="8">
                    <el-row>
                      <el-col :span="1">
                        <el-button circle size="mini" style="background-color: yellow;" />
                      </el-col>
                      <el-col :span="23">
                        <div style="font-size: 14px;text-align: center;margin-top: 8px;margin-left: -10px;">
                          “黄色”患者人次
                        </div>
                      </el-col>
                    </el-row>

                    <el-row style="margin-top: 5px; margin-bottom: 5px">
                      <div style="font-size: 24px; color: #68bbc4; font-weight: bold;text-align: center;">
                        340人次
                      </div>
                    </el-row>
                  </el-col>

                  <!-- 绿色患者人次 -->
                  <el-col :span="8">
                    <el-row>
                      <el-col :span="1">
                        <el-button circle size="mini" style="background-color: green;" />
                      </el-col>
                      <el-col :span="23">
                        <div style="font-size: 14px;text-align: center;margin-top: 8px;margin-left: -10px;">
                          “绿色”患者人次
                        </div>
                      </el-col>
                    </el-row>

                    <el-row style="margin-top: 5px; margin-bottom: 5px">
                      <div style="font-size: 24px; color: #68bbc4; font-weight: bold;text-align: center;">
                        254人次
                      </div>
                    </el-row>
                  </el-col>

                </el-row>

                <el-row style="margin-top: 10px; width: 410px">
                  <el-row>
                    <el-col :span="1">
                      <el-button circle size="mini" style="background-color: cornflowerblue;" />
                    </el-col>

                    <el-col :span="7">
                      <div style="
                              font-size: 14px;
                              text-align: left;
                              margin-top: 7px;
                              margin-left: 10px;
                            ">
                        协诊规范人次
                      </div>
                    </el-col>

                    <el-col :span="6" style="margin-top: 0px; margin-bottom: 15px;">
                      <div style="
                              font-size: 24px;
                              color: orange;
                              font-weight: bold;
                              text-align: left;
                            ">
                        59.2%
                      </div>
                    </el-col>

                    <el-col :span="10" style="margin-top: 0px; margin-bottom: 15px;">
                      <div style="
                              font-size: 24px;
                              color: #68bbc4;
                              font-weight: bold;
                              text-align: left;
                            ">
                        408人次
                      </div>
                    </el-col>

                  </el-row>

                  <el-row>
                    <StackedHorizontalChart />
                  </el-row>
                </el-row>

                <el-row style="width: 410px; margin-left: 22px">
                  <el-col :span="1">
                    <img style="
                      margin-left: -34px;
                      margin-top: 20px;
                      width: 30px;
                      height: 20px;
                    " :src="linkLine" />
                  </el-col>

                  <el-col :span="23" style="margin-top: 20px;">
                    <span style="margin-left: -30px;">随访规范</span>
                  </el-col>
                </el-row>

                <el-row style="margin-top: 10px; width: 410px">
                  <el-row>
                    <el-col :span="1">
                      <el-button circle size="mini" style="background-color: cornflowerblue;" />
                    </el-col>

                    <el-col :span="7">
                      <div style="
                              font-size: 14px;
                              text-align: left;
                              margin-top: 7px;
                              margin-left: 10px;
                            ">
                        随访规范人数
                      </div>
                    </el-col>

                    <el-col :span="6" style="margin-top: 0px; margin-bottom: 15px;">
                      <div style="
                              font-size: 24px;
                              color: orange;
                              font-weight: bold;
                              text-align: left;
                            ">
                       {{ detail.followupCount }}
                      </div>
                    </el-col>

                    <el-col :span="10" style="margin-top: 0px; margin-bottom: 15px;">
                      <div style="
                              font-size: 24px;
                              color: #68bbc4;
                              font-weight: bold;
                              text-align: left;
                            ">
                        {{ detail.followupPersonCount + '人次' }}
                      </div>
                    </el-col>

                  </el-row>

                  <el-row>
                    <pie-chart :chart-data="followUpChartData1" @chartClick="clickIncomePie" />
                  </el-row>
                </el-row>
              </el-card>
            </el-col>

            <el-col style="width: 250px;margin-left: 5px;">
              <el-card style="
                margin-top: 0px;
                margin-left: 0px;
                margin-right: 5px;
                margin-bottom: 10px;
                width: 250px;
              ">
                <el-row style="width: 210px; margin-left: 22px">
                  <el-col :span="2">
                    <img style="
                      margin-left: -34px;
                      margin-top: 0px;
                      width: 30px;
                      height: 20px;
                    " :src="linkLine" />
                  </el-col>

                  <el-col :span="22">
                    <span style="margin-left: -25px">健康管理</span>
                  </el-col>
                </el-row>

                <!-- 规范健康管理人次 -->
                <el-row style="margin-top: 10px; width: 210px">
                  <el-card class="cardColor2">
                    <div>
                      <el-row>
                        <div style="font-size: 14px; color: #fff; font-weight: bold">
                          规范健康管理人次
                        </div>
                      </el-row>

                      <el-row style="margin-top: 10px; margin-bottom: 10px">
                        <div style="font-size: 24px; color: #fff; font-weight: bold">
                          {{ detail.healthMngStdPersons }}
                        </div>
                      </el-row>

                      <el-row style="background-color: #fff;height: 1px;"></el-row>

                      <el-row style="margin-top: 20px;">
                        <div style="font-size: 14px; color: #fff; font-weight: bold">
                          月同比 16%
                          <i class="el-icon-caret-top" style="color: red;"></i>
                        </div>
                      </el-row>
                    </div>
                  </el-card>
                </el-row>

                <!-- 65岁及以上规范健康管理人次 -->
                <el-row style="margin-top: 10px; width: 210px">
                  <el-card class="cardColor1">
                    <div>
                      <el-row>
                        <div style="font-size: 14px; color: #fff; font-weight: bold">
                          65岁及以上规范健康管理人次
                        </div>
                      </el-row>

                      <el-row style="margin-top: 10px; margin-bottom: 10px">
                        <div style="font-size: 24px; color: #fff; font-weight: bold">
                          {{ detail.healthMngStdPersonsGe65old }}
                        </div>
                      </el-row>

                      <el-row style="background-color: #fff;height: 1px;"></el-row>

                      <el-row style="margin-top: 20px;">
                        <div style="font-size: 14px; color: #fff; font-weight: bold">
                          月同比 16%
                          <i class="el-icon-caret-top" style="color: red;"></i>
                        </div>
                      </el-row>

                    </div>
                  </el-card>
                </el-row>

                <el-row style="margin-top: 20px;margin-left: 10px;">
                  <el-row>
                    <el-col :span="2">
                      <el-button circle size="mini" style="background-color: cornflowerblue;" />
                    </el-col>
                    <el-col :span="22">
                      <div style="font-size: 14px;text-align: left;margin-top: 7px;margin-left: 10px;">
                        规范健康管理率
                      </div>
                    </el-col>
                  </el-row>

                  <el-row style="margin-top: 20px; margin-bottom: 5px;margin-left: 5px;">
                    <div style="font-size: 24px; color: #68bbc4; font-weight: bold;text-align: left;">
                      81.4%
                    </div>
                  </el-row>
                </el-row>

                <el-row style="margin-top: 10px;margin-left: 10px;margin-bottom: 88px;">
                  <el-row>
                    <el-col :span="2">
                      <el-button circle size="mini" style="background-color: green;" />
                    </el-col>
                    <el-col :span="22">
                      <div style="font-size: 14px;text-align: left;margin-top: 7px;margin-left: 10px;">
                        健康管理率
                      </div>
                    </el-col>
                  </el-row>

                  <el-row style="margin-top: 10px; margin-bottom: 5px;margin-left: 5px;">
                    <div style="font-size: 24px; color: #68bbc4; font-weight: bold;text-align: left;">
                      72.6%
                    </div>
                  </el-row>
                </el-row>

              </el-card>
            </el-col>
          </div>
        </el-card>
      </el-row>

      <el-row style="margin-top: 20px;">
        <el-card style="margin-left:20px;margin-top: 0px; margin-bottom: 20px; width: 980px;">
          <div slot="header" class="clearfix">
            <span>高危患者规范管理</span>
            <el-menu style="float: right;margin-top: -21px;" default-active="1" mode="horizontal">
              <el-menu-item index="1">月</el-menu-item>
              <el-menu-item index="2">季</el-menu-item>
              <el-menu-item index="3">年</el-menu-item>
            </el-menu>
          </div>
          <div>
            <el-row>
              <el-col :span="15">
                <el-row style="width: 300px; margin-left: 22px">
                  <el-col :span="2">
                    <img style="
                      margin-left: -34px;
                      margin-top: 0px;
                      width: 30px;
                      height: 20px;
                    " :src="linkLine" />
                  </el-col>

                  <el-col :span="22">
                    <span style="margin-left: -30px">血糖检测规范</span>
                  </el-col>
                </el-row>
                <el-row style="width: 580px;">
                  <MixLineBarChart :chartData="mixLineBarChartdata" />
                </el-row>
              </el-col>

              <el-col :span="9">
                <el-row style="margin-top: 0px; width: 300px; margin-left: 22px">
                  <el-col :span="2">
                    <img style="
                      margin-left: -34px;
                      margin-top: 0px;
                      width: 30px;
                      height: 20px;
                    " :src="linkLine" />
                  </el-col>

                  <el-col :span="22">
                    <span style="margin-left: -30px">随访规范</span>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="8">
                    <div style="
                              font-size: 14px;
                              color: #7b7b7f;
                              font-weight: bold;
                              text-align: center;
                              margin-top: 20px;
                            ">
                      随访规范人次
                    </div>
                  </el-col>

                  <el-col :span="16" style="margin-top: 10px; margin-bottom: 15px;">
                    <div style="
                              font-size: 26px;
                              font-weight: bold;
                              text-align: left;
                            ">
                      105.6
                    </div>
                  </el-col>
                </el-row>

                <el-row>
                  <pie-chart :chart-data="followUpChartData2" @chartClick="clickIncomePie" />
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-row>

    </el-container>
  </div>
</template>

<script>
import { getAppDiabetSpecData } from "@/api/health/Patients";
import ScatterPlotCharts from "../charts/bi_scatter";
import RadarChart from "../charts/RadarChart";
import StackedColumnChart from "../charts/StackedColumnChart";
import StackedHorizontalChart from "../charts/StackedHorizontalChart";
import ScatterChart from "../charts/ScatterChart";
import PieChart from "../charts/PieChart.vue"
import MixLineBarChart from "../charts/MixLineBarChart";
import MutilateBarChart from "../charts/MutilateBarChart";
import BasicBarChart from "../charts/BasicBarChart";
import moment from "moment";

import imageLine from "@/assets/images/titleLine.png";
import { color } from "echarts";

export default {
  components: {
    ScatterPlotCharts,
    RadarChart,
    StackedColumnChart,
    StackedHorizontalChart,
    ScatterChart,
    PieChart,
    MixLineBarChart,
    MutilateBarChart,
    BasicBarChart
  },
  data() {
    return {
      dialogDeptTableVisible: false,
      allDeptDataList: null,
      allDeptDataListLoading: false,
      list: null,
      listLoading: false,
      listQuery: {
        name: null,
      },
      medicalQualitySortVisible: false,
      medicalEffciencySortVisible: false,
      operativeIndexVisible: false,
      profitDiseaseSortVisible: false,
      hospitalizationIncomeVisible: false,
      outpatientIncomeVisible: false,
      medicalServiceDetailVisible: false,
      linkLine: imageLine,
      detail: null,
      deptTopType: "年",
      drgTopType: "智能排序",
      period: '年',
      periodMonth: null,
      periodYear: null,
      periodQuarter: null,
      periodOptions: [
        { value: "月", label: "月" },
        { value: "季", label: "季" },
        { value: "年", label: "年" }
      ],
      periodQuarterOptions: [
        { value: "1", label: "第一季度" },
        { value: "2", label: "第二季度" },
        { value: "3", label: "第三季度" },
        { value: "4", label: "第四季度" }
      ],
      followUpChartData1: [
        { value: 235, name: "随访规范人次" },
        { value: 60, name: "1次未达标且2周内未随访人次" },
        { value: 48, name: "连续2次未达标且未转诊/协诊人次" }
      ],
      followUpChartData2: [
        { value: 100, name: "第五人民医院" },
        { value: 150, name: "黄山卫生院" },
        { value: 152, name: "易通路社区卫生服务中心" },
        { value: 200, name: "兰东路社区卫生服务中心" },
        { value: 114, name: "佳家康社区卫生服务中心" }
      ],
      bgChartData: [
        { value: 55, name: "不规范人数" },
        { value: 368, name: "规范人数" }
      ],
      mixLineBarChartdata: {
        titleData: "血糖规范检测",
        lineName: "血糖检测规范人数",
        barName: "规范人数占比",
        xAxisData: ["第五人民医院", "黄山卫生院", "易通路社区卫生服务中心", "兰东路社区卫生服务中心", "佳家康社区卫生服务中心", "区立医院"],
        lineData: [0.67, 0.63, 0.52, 0.55, 0.42, 0.44],
        barData: [61, 55, 46, 48, 52, 26]
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    clickIncomePie(event) {
      console.log("点击p");
      console.log(event);
    },
    clearEvent() {
      this.listQuery.name = null;
      // this.getList();
    },
    getList() {
      console.log('月', this.periodMonth);
      console.log('季', this.periodQuarter);
      console.log('年', this.periodYear);

      var periodData = {
        "period": '2023'
      };
      getAppDiabetSpecData(periodData).then(res => {
        var records = [];
        if (res.msg == "success") {
          var data = res.data;
          records = data.records;
          this.detail = records[0];

          // if(this.detail.measBsPersonCount != null || this.detail.measBsStdPersonCount != null){
          //   var value = { value: this.measBsStdPersonCount, name: "规范人数" };
          //   var stdValue = { value: this.detail.measBsPersonCount-this.measBsStdPersonCount, name: "不规范人数" };
          //   this.bgChartData.push(value,stdValue);
          // }

          // var followUpChartData = [
          //   { value: this.detail.followupStdCount, name: "随访规范人次" },
          //   { value: this.detail.followup1wNonstdCount, name: "1次未达标且2周内未随访人次" },
          //   { value: this.detail.followup2wNonstdCount, name: "连续2次未达标且未转诊/协诊人次" }
          // ];
          // this.followUpChartData1 = followUpChartData;

        }
        console.log("首页数据：", res);
      }).catch(err => {
        console.log(err);
      })
    },
    exportList() { },
    getParsedTime(time) {
      return moment(time).format("YYYY-MM-DD HH:mm");
    },
  },
};
</script>

<style>
.box-card {
  width: 1443px;
}

.card-panel-col {
  display: flex;
  flex-direction: row;
  margin-left: 10px;
}

.card-panel-icon-wrapper {
  display: flex;
  width: 60px;
  height: 60px;
  flex-direction: column;
  justify-content: center;
  /* 水平居中*/
  align-items: center;
  margin-bottom: 10px;
}

.image {
  width: 50px;
  height: 50px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: none;
}

.cardImage1 {
  width: 80px;
  height: 80px;
}

.cardImage2 {
  width: 65px;
  height: 65px;
}

.card-panel-icon-wrapper2 {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  /* 水平居中*/
  align-items: center;
  margin-bottom: 10px;
}

.image2 {
  width: 50px;
  height: 50px;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  /* 水平居中*/
  align-items: center;
}

.cardColor1 {
  background: linear-gradient(to right, #9fccfc, #618bff);
}

.cardColor2 {
  background: linear-gradient(to right, #a4aefc, #6089ff);
}

.el-progress-bar__inner {
  background-color: unset;
  background-image: linear-gradient(to right, #6855ff, #5aa2eb);
}
</style>